

function getProductMarkup(product){
  return `
  <div class="card-wrapper product-card-wrapper underline-links-hover">
    <button 
      aria-label="Delete" 
      data-variant-id="${product.epi}" 
      data-product-id="${product.empi}" 
      class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
      <span class="swym-icon">♥</span>
    </button>
    <div class="card card--standard card--media">
      <div class="card__inner color-background-2 gradient ratio">
        <div class="card__media">
          <div class="media media--transparent media--hover-effect">
            <img src="${product.iu.replace('620x620', '2000x2000')}" class="motion-reduce" loading="lazy" />
          </div>
        </div>
        <div class="card__content" onclick="window.location.href='${product.du}'">
          <div class="card__information">
            <h3 class="card__heading">
              <a href="${product.du}" class="full-unstyled-link"> ${product.dt} </a>
            </h3>
          </div>
        </div>
      </div>
      <div class="card__content" >
        <div class="card-information">
          <span class="caption-large light"></span>
          <div class="price">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price-item price-item--regular"> ${product.cu}${product.pr} </span>
              </div>
            </div>
          </div>
        </div>
        <h3 class="card__heading h5">
          <a href="${product.du}" class="full-unstyled-link card-style-title"> ${product.dt} </a>
        </h3>
      </div>
    </div>
  </div>
`;
}

function swymRenderWishlist(swat) {

  const wishlistContainer = document.querySelector(".wishlist-grid");
  
  const elementsToRemove = wishlistContainer.querySelectorAll(".grid__item");
  elementsToRemove.forEach(element => element.remove());

  swat.fetch(function(products) {
      const formattedWishlistedProducts = products.map(function(p) {
          p = SwymUtils.formatProductPrice(p);
          p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
          return p;
      });

      const productCardsMarkup = formattedWishlistedProducts.map(prod => getProductMarkup(prod))
    
      if(wishlistContainer){
          productCardsMarkup.forEach(card => {
            const li = document.createElement("li");
            li.classList.add("grid__item");
            li.innerHTML = card;
            wishlistContainer.append(li);
          })
		 attachClickListeners();
      }
    
  });
}

function attachClickListeners(){
  var removeBtns = document.querySelectorAll(".wishlist-grid .swym-delete-btn");
  (Array.from(removeBtns) ?? []).forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
    	const epi = +e.currentTarget.getAttribute("data-variant-id");
    	const empi = +e.currentTarget.getAttribute("data-product-id");
        
    	window._swat.fetch(function(products) {
    		products.forEach(function(product) {
    			if (epi && empi && product.epi == epi && product.empi == empi) {
    				window._swat.removeFromWishList(product, function() {
    					if (!window.SwymCallbacks) {
    						window.SwymCallbacks = [];
    					}
    					window.SwymCallbacks.push(swymRenderWishlist);
    				});
    			}
    		});
    	})
      
    }, false);
  });
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);